import { toCanvas } from "html-to-image";

const TITLE_HEIGHT = 56;
const PADDING = 24;

function download(href, filename) {
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
}

// Renders the full roster table (not just the scrolled viewport) onto a canvas
// with a title band above it.
async function renderRosterCanvas(tableEl, title) {
  const pixelRatio = 2;
  const tableCanvas = await toCanvas(tableEl, {
    pixelRatio,
    backgroundColor: "#ffffff",
    width: tableEl.scrollWidth,
    height: tableEl.scrollHeight,
    cacheBust: true,
  });

  const pad = PADDING * pixelRatio;
  const titleH = TITLE_HEIGHT * pixelRatio;
  const canvas = document.createElement("canvas");
  canvas.width = tableCanvas.width + pad * 2;
  canvas.height = tableCanvas.height + titleH + pad;

  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "#0f172a";
  ctx.font = `700 ${20 * pixelRatio}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;
  ctx.textBaseline = "middle";
  ctx.fillText(title, pad, titleH / 2 + pad / 4);
  ctx.drawImage(tableCanvas, pad, titleH);

  return canvas;
}

export async function exportRosterImage(tableEl, { title, filename, format }) {
  const canvas = await renderRosterCanvas(tableEl, title);
  const mime = format === "jpeg" ? "image/jpeg" : "image/png";
  const ext = format === "jpeg" ? "jpg" : "png";
  download(canvas.toDataURL(mime, 0.95), `${filename}.${ext}`);
}

export async function exportRosterPdf(tableEl, { title, filename }) {
  const [{ jsPDF }, canvas] = await Promise.all([
    import("jspdf"),
    renderRosterCanvas(tableEl, title),
  ]);
  // Single landscape page sized to the roster so nothing is cut or shrunk.
  const w = canvas.width / 2;
  const h = canvas.height / 2;
  const pdf = new jsPDF({
    orientation: w >= h ? "landscape" : "portrait",
    unit: "px",
    format: [w, h],
    hotfixes: ["px_scaling"],
  });
  pdf.addImage(canvas.toDataURL("image/jpeg", 0.95), "JPEG", 0, 0, w, h);
  pdf.save(`${filename}.pdf`);
}
